import { getFlowpageHost } from '@dtx-company/true-common/src/utils/urls/host'
import { shouldUseFlowcodeDomain } from '@dtx-company/inter-app/src/utils/user/getDefaultFlowpageDomain'
import { useCurrentUserPlan } from '@dtx-company/inter-app/src/redux/selectors/currentUserSelectors'

export const useFlowpageHost = (): string => {
  const plan = useCurrentUserPlan()
  return getFlowpageHost(shouldUseFlowcodeDomain(plan))
}

export const useFlowpageUrlRoot = (): string => {
  const host = useFlowpageHost()
  return `https://${host}/`
}

export function useSlugToUrl(slug?: string): string | undefined {
  const flowpageUrlRoot = useFlowpageUrlRoot()
  return slug ? `${flowpageUrlRoot}${slug}` : undefined
}

export function useSlugToUrlFullRoute(slug?: string, domain?: string | null): string {
  const flowpageUrlRoot = useFlowpageUrlRoot()
  if (!slug) return ''
  return (domain ? domain : flowpageUrlRoot) + slug?.toLowerCase()
}

export function useSlugToDisplayUrl(slug?: string): string | undefined {
  const flowpageRoot = useFlowpageHost()
  return slug ? `${flowpageRoot}/${slug.toLowerCase()}` : undefined
}
